import {
  type TableColumnFormatMplsNextHop,
  formatMplsNextHopValue,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import {
  ARRAY_CELL_MAX_ITEMS,
  maybeWrapWithMore,
} from 'components/Table/cells/helpers/trimLargeArray';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderMplsNextHopCell = <TRow,>(
  format: TableColumnFormatMplsNextHop<TRow>,
  { row }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const content = getValueFromKeyOfType(row, format.field);
  if (!content) {
    return {
      content: null,
    };
  }

  return {
    content: Array.isArray(content)
      ? pipe(
          content,
          (a) => a.slice(0, ARRAY_CELL_MAX_ITEMS),
          array.map(formatMplsNextHopValue),
          (a) => a.join(', '),
          maybeWrapWithMore(content),
        )
      : formatMplsNextHopValue(content),
  };
};
